<div class="file-select-container">
  <div
    class="drag-and-drop-container"
    (click)="fileInput.click()"
    dragAndDropUpload
    (fileDropped)="onSelectFile($event)"
    [attr.data-test]="dataTestId">
    <input
      #fileInput
      hidden
      type="file"
      accept="{{ SVGMimeType ? SVGMimeType : customMineTypes.join(', ') }}"
      [disabled]="disabled"
      id="uploadbutton"
      (change)="onSelectFile($event.target.files[0])" />
    <div class="file-container" *ngIf="logo; else uploadText">
      <div class="overlay">
        <ng-container [ngTemplateOutlet]="uploadText"></ng-container>
      </div>
    </div>
    <div *ngIf="!logo && loading">
      <spinner></spinner>
    </div>
  </div>
  <div *ngIf="logo?.fileName && !logo.defaultLogo" class="file-name-container">
    <div class="file-name-with-icon" matTooltip="{{ logo.fileName }}" [matTooltipShowDelay]="300">
      <eop-logo-preview [logo]="logo"></eop-logo-preview>
      <span class="body-s">{{ logo.fileName }}</span>
    </div>
    <eop-icon
      identifier="close-circle-filled"
      [size]="IconSize.SMALL"
      (click)="removeLogo()"></eop-icon>
  </div>
</div>
<ng-template #uploadText>
  <span class="body-l text-center">{{ 'TERMINAL_MANAGEMENT.UPLOAD_DRAG_DROP' | translate }}</span>
  <span class="restriction-text">{{ uploadInfoText }}</span>
</ng-template>
